import {React, observer, Fragment, Popover2, classNames} from '@api'
import {PrimaryIconButton} from 'centric-ui-components'
import {PresentationSettingsToolbarButton, usePresentationModeContentStore} from './'
import * as css from './Header.css'

export const Header = observer<{className?: string}>(function Header({className}) {
    const {flexLayout: {activeTab: {displayName}}, settings: {fullScreen}, hideToolbars, toggleShow} = usePresentationModeContentStore()

    if (!fullScreen) return null

    return (<div className={classNames(css.root, className)} data-hide={hideToolbars}>
        <div className={css.title}>{displayName}</div>

        <div data-type='toolbarButtons'>
            <PrimaryIconButton icon='cross' onClick={toggleShow} tooltip='Close Presentation'/>
            <PresentationSettingsToolbarButton className={css.menu} />
        </div>
    </div>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/Header.tsx